import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGeographicCityQuickInfo extends Layout {
    panelCityQuickInfo: Panel;
    sourceGeographicCity: DataSource;
    textboxCounty: Textbox;
    textboxName: Textbox;
    textboxNumber: Textbox;
    textboxState: Textbox;
    textboxZipCode: Textbox;
}
